<h2 mat-dialog-title>{{'get_event_log.query_event_logs' | translate}}</h2>
<div *ngIf="controls">
    <mat-form-field style="width: 285px;" floatLabel="always" appearance="outline" class="log-type">
        <mat-label>{{'get_event_log.type_of_magazine' | translate}}</mat-label>
        <mat-select [(ngModel)]="eventLogsSendObject.management['event_index']" [disabled]="disableEdit">
            <mat-option style="white-space: unset; height: 3.5rem; line-height: 16px;"
                        *ngFor="let type of controls['event_log']['properties']; let i = index" [value]="i">
                {{ type }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <button
        style="margin-left: 15px; height: 50px; margin-bottom: 15px; vertical-align: middle"
        mat-raised-button
        color="primary"
        (click)="getEventLogs()"
        [disabled]="disableEdit"
    >
        {{'get_event_log.request' | translate}}
    </button>
</div>
